// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1VXoY","large":"styles_large__31kgg"};